import styled from "styled-components";

export default styled.div`
  flex: 1;
`;
